export enum ProductType {
  ABS = 'ABS',
  HYC = 'HYC',
  IGC = 'IGC',
  LM = 'LM',
}

export enum ProductAbbreviations {
  ABS = 'ABS',
  HYC = 'HYC',
  IGC = 'IGC',
  LM = 'LM',
  CORPORATE = 'CORPORATE',
}
